import { FC } from 'react';

import VerticalFAQItem from './VerticalFAQItem';

import styles from './VerticalFAQ.module.scss';

interface FAQ {
  answer: string;
  question: string;
}

interface Props {
  faqs: Array<FAQ>;
  title: string;
}

export const VerticalFAQ: FC<Props> = ({ faqs, title }) => (
  <div className={styles['vertical-faq']} data-test-id="faq-section">
    <h2>{title}</h2>
    <div className={styles['vertical-faq-items']}>
      {faqs.map((faq) => (
        <VerticalFAQItem key={faq.answer} contents={faq.answer} title={faq.question} />
      ))}
    </div>
  </div>
);

export default VerticalFAQ;
export type { Props as VerticalFAQItemProps };
